/*eslint-disable */

import {
  bus
} from '@/main';
import commonSocket from "@/commonSocket/index.js";
import {
  mapGetters
} from 'vuex';

const $ = window.jQuery = require('jquery');
export default {
  name: 'forward-msg-popup',
  components: {},
  props: ['forwardMsgInfo', 'roomSocketUrl', 'chatRoomInfo'],
  data () {
    return {
      normalViewUserChatList:true,
      searchEnabled:false,
      search_term:'',
      allUserData:null,
      allUserDataResults:[],
      selfUserId:'',
      forwardMsgToSelctedUserInfo:[],
      forwardMsgToSelctedUserId:[],
      forwardMsgToSelctedChatRoomId:[],
      checkbox:'',
      submitted:false,
      sendNewRoomIdForMsg:'',
      pinnedChatRoomListData:null,
      pinnedChatRoomList:[],
      fullChatRoomListData:null,
      fullChatRoomListResult: [],
      totalChatListOfLoadMore:'',
      fullChatData:null
    }
  },
  computed: {
    ...mapGetters([
      'getAllLeftChatListDetailsGetters'
    ]),
    getAllRoomChatListFun() {
      this.fullChatData = this.$store.getters.getAllLeftChatListDetailsGetters.data;
      return;
    },
    setInitialStatesFunc(){
      if(this.fullChatData){
        this.pinnedChatRoomListData = this.fullChatData;
        this.pinnedChatRoomList = this.pinnedChatRoomListData.pinned_chat;
        this.fullChatRoomListData  = this.fullChatData.full_chat;
        this.fullChatRoomListResult = this.fullChatRoomListData.results;
        this.fullChatListForLoadMore = this.fullChatRoomListData.next;
      }
    },
  },
  mounted () {
    this.getAllRoomChatListFun;
    this.setInitialStatesFunc;
    this.selfUserId = localStorage.getItem('LoginedUserID');
    document.body.classList.add('body_right_scroll_remove');
  },
  methods: {
    searchEnabledMethod(){
      this.searchEnabled = true;
    },

    searchBarForChatClosedFun(){
      this.searchEnabled = false;
      this.search_term = '';
      this.normalViewUserChatList = true;
    },

    onChangeSearchUser(){
      if(this.search_term.length >= 3){
        var searchListTimeOut = setTimeout(()=>{
          this.$store.dispatch('seachUserOfChatInWorkspaceAction', { query: this.search_term }).then((response) => {
            this.normalViewUserChatList = false;
            this.allUserDataResults = response.data.data;
          })
          clearTimeout(searchListTimeOut);
       },1000)
      }else{
        this.normalViewUserChatList = true;
      }
    },
    
    forwardMsgPopupClosed(){
      bus.$emit('messageSearchPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('forwardMsgPopupBus', false);
    },

    getChatRoomIdsMethod(info){
      this.forwardMsgToSelctedChatRoomId= [];
      info.map((item) => {
        this.forwardMsgToSelctedChatRoomId.push(item.chat_room);
      })
      return  this.forwardMsgToSelctedChatRoomId;
    },
    
    getChatUserIdMethod(info){
      this.forwardMsgToSelctedUserId= [];
      info.map((item) => {
        this.forwardMsgToSelctedUserId.push(item.user.id);
      })
      return this.forwardMsgToSelctedUserId;
    },

    getForwarededMessagesIdsMethod(messages){
      const messageIds = [];
      messages.map((item) => {
        messageIds.push(item.id);
      })
      return  messageIds;
    },

    forwardMsgToSelctedUserMethod() {
      const roomIds = this.getChatRoomIdsMethod(this.forwardMsgToSelctedUserInfo);
      const messageIds = this.getForwarededMessagesIdsMethod(this.forwardMsgInfo);
      if(this.roomSocketUrl){
        this.roomSocketUrl.send(JSON.stringify({
          type: 'forward_message',
          message_id: messageIds,
          new_chat_room_id:roomIds,
        }));
      }
      this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
       this.forwardMsgPopupClosed();
      });
    }
  },
  watch:{
    getAllRoomChatListData() {
      return this.$store.getters.getAllLeftChatListDetailsGetters;
    },
    setInitialStatesFunc(){
      if(this.fullChatData){
        this.pinnedChatRoomListData = this.fullChatData;
        this.pinnedChatRoomList = this.pinnedChatRoomListData.pinned_chat;
        this.fullChatRoomListData  = this.fullChatData.full_chat;
        this.fullChatRoomListResult = this.fullChatRoomListData.results;
        this.fullChatListForLoadMore = this.fullChatRoomListData.next;
      }
    }
  }
}